import { LocalStorageClient } from 'core/infra/storage/LocalStorageClient'

import { AgnosticStrongAuthRepository } from '../infra/AgnosticStrongAuthRepository'
import { createAgnosticHttpClient } from '../infra/createAgnosticHttpClient'

export async function exchangeAgnosticRateToken({
  entityIdentifier,
  accessToken,
}: {
  entityIdentifier: string
  accessToken: string
}): Promise<string> {
  const repository = new AgnosticStrongAuthRepository({
    httpClient: createAgnosticHttpClient(accessToken),
    storage: new LocalStorageClient(),
  })

  return repository.fetchAccessToken({ entityIdentifier })
}
